import makeStyles from "@material-ui/core/styles/makeStyles";
import {
  ERROR_BACKGROUND,
  ERROR_COLOR,
  SUCCESS_BACKGROUND,
  SUCCESS_COLOR
} from "../../../../../../../themes/themeConfigurator";

const useStyles = makeStyles((theme) => ({
  badgeRow: {
    overflow: 'hidden',
  },
  badgeItem: {
    minWidth: 0,
    overflow: 'hidden',
    flex: '1 1 0',
    maxWidth: 'fit-content',
  },
  editButton: {
    flexShrink: 0,
  },
  chip: {
    backgroundColor: SUCCESS_BACKGROUND,
    color: SUCCESS_COLOR,
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    height: 22,
    maxWidth: '100%',

    '&.error': {
      backgroundColor: ERROR_BACKGROUND,
      color: ERROR_COLOR,
    }
  },
  costLine: {
    margin: '4px 0',
    fontSize: 12,
    fontFamily: 'Roboto-Regular',
  },
}));

export default useStyles;
